import { FC, useEffect } from 'react';

import { notFound } from 'store/errorSlice';

import { useAppDispatch } from 'hooks/defaultStoreHooks';

import { DrawerBody, DrawerContainer, NavigationDrawerHead } from 'components/drawerSections/DrawerSections';

const NotFound: FC = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(notFound(false));
  }, [dispatch]);

  return (
    <DrawerContainer>
      <NavigationDrawerHead />
      <DrawerBody>
        <div className="tw-flex tw-h-full tw-items-center tw-justify-center">
          <h1 className="tw-heading-lg">Sidan hittades inte</h1>
        </div>
      </DrawerBody>
    </DrawerContainer>
  );
};

export default NotFound;
